module.exports = __webpack_public_path__ + "static/media/logoDrawer.572fa687.png";